// Aún no se usan: el módulo se controla con AT_COOPCONFIG (usa_at). Se dejan centralizados por si backend define permisos para el módulo.
export const PERMISSIONS = {
  ASISTENCIA_TECNICA: 'ASISTENCIA_TECNICA',
  AT_CAPACITACIONES: 'AT_CAPACITACIONES',
  AT_VISITAS: 'AT_VISITAS',
};

export const BASE_PATH = '/asistencia-tecnica';
export const CAPACITACIONES_PATH = `${BASE_PATH}/capacitaciones`;
export const VISITAS_PATH = `${BASE_PATH}/visitas`;

// Ficha del productor (cuenta) en la app legacy; requiere el uuid de la cuenta.
export const CUENTA_PERFIL_PATH = '/admin/cuentas/perfil';

// Módulo visible solo si la cooperativa tiene usa_at = 1 (cooperativa_conf).
export const AT_COOPCONFIG = { variable: 'usa_at', cond: '=', value: '1' };
